<template>
  <div>
    <label>{{label}}</label>
    <div class="row">
      <div class="col-md-3 pr-md-2">
        <select type="date" class="form-control" id="day" @change="onDateSelectorChange" v-model="birthDayValue"
                :class="error || errors.birthDay?'form-control form-error': 'form-control'">
          <option value="0" :selected="birthDayValue == 0">{{ $t('Día') }}</option>
          <option :value="index" v-for="index in 31" :key="index" :selected="birthDayValue == index">{{index}}</option>
        </select>
      </div>
      <div class="col-md-5 p-md-0 py-2 py-md-0">
        <select type="date" class="form-control" id="month" @change="onDateSelectorChange" v-model="birthMonthValue"
          :class="error || errors.birthMonth?'form-control form-error': 'form-control'">
          <option value="0" :selected="birthMonthValue == 0">{{ $t('Mes') }}</option>
          <option :value="m.value" v-for="m in months" :key="m.value" :selected="birthMonthValue == m.value">{{ m.label }}</option>
        </select>
      </div>
      <div class="col-md-4 pl-md-2">
        <select class="form-control" id="year" @change="onDateSelectorChange" v-model="birthYearValue"
        :class="error || errors.birthYear?'form-control form-error': 'form-control'">
          <option value="0" :selected="birthYearValue == 0">{{ $t('Año') }}</option>
          <option :value="year" v-for="year in yearRange" :key="year" :selected="birthYearValue == year">{{year}}</option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment';
  export default {
    name: 'date-selector',
    props: ['date', 'label', 'minYear', 'maxYear', 'error'],
    data: function () {
      return  {
        birthDayValue: 0,
        birthMonthValue: 0,
        birthYearValue: 0,
        errors: {
          birthDay: false,
          birthMonth: false,
          birthYear: false,
        }
      }
    },
    computed: {
      months: function () {
        const locale = this.$locale();
        return [1,2,3,4,5,6,7,8,9,10,11,12].map((value) => ({
          value,
          label: moment().locale(locale).month(value - 1).format('MMMM'),
        }));
      },
      yearRange: function() {
        var list = [];
        if (this.minYear != undefined && this.maxYear != undefined) {
          for (var i=this.minYear; i <= this.maxYear; i++) {
            list.push(i)
          }
        } else {
          var currentYear = moment().year()
          for (var i=1916; i <= currentYear; i++) {
            list.push(i)
          }
        }
        return list.reverse();
      },
    },
    watch: {
      date: function () {
        this.updateFromDate();
      }
    },
    mounted: function () {
      this.updateFromDate();
    },
    methods: {
      updateFromDate: function () {
        if (this.date) {
          var d = moment(this.date, "YYYY-MM-DD")
          if (d.isValid()) {
            this.birthDayValue = d.date();
            this.birthMonthValue = d.month() + 1;
            this.birthYearValue = d.year();
          }
        }
      },
      onDateSelectorChange: function () {
        if (this.birthDayValue > 0
          && this.birthMonthValue > 0
          && this.birthYearValue > 0) {
          this.errors.birthYear = false;
          this.errors.birthMonth = false;
          this.errors.birthDay = false;
          this.$emit('update:date', moment({
            y: this.birthYearValue,
            M: this.birthMonthValue - 1,
            d: this.birthDayValue
          }).format("YYYY-MM-DD"));
        }
      },
      validate: function() {
        this.errors.birthDay = this.birthDayValue == 0;
        this.errors.birthMonth = this.birthMonthValue == 0;
        this.errors.birthYear = this.birthYearValue == 0;

        var isValid = true;
        isValid = isValid && !this.errors.birthDay;
        isValid = isValid && !this.errors.birthMonth;
        isValid = isValid && !this.errors.birthYear;
        return isValid;
      },
    }
  }
</script>
